// Select Component
const SELECTORS = {
    selectfield: '.js-select'
}

const CLASSES = {
    isFocused: 'is-focused',
    isDirty: 'is-dirty'
}

class SelectField {
    constructor(el) {
        this.element = el
        this.input = this.element.querySelector('select')

        this.bindEvents()
        this.checkDirty()
    }

    bindEvents() {
        this.input.addEventListener('focus', (e) => this.onFocus())
        this.input.addEventListener('blur', (e) => this.onBlur())
        this.input.addEventListener('change', (e) => this.checkDirty())
    }

    onFocus() {
        this.element.classList.add(CLASSES.isFocused)
    }

    onBlur() {
        this.element.classList.remove(CLASSES.isFocused)
        this.checkDirty()
    }

    checkDirty() {
        const isDirty = this.input.value && this.input.value.length > 0
        if (isDirty) {
            this.element.classList.add(CLASSES.isDirty)
        } else {
            this.element.classList.remove(CLASSES.isDirty)
        }
    }
}

// Register All selects
const selectFields = document.querySelectorAll(SELECTORS.selectfield)
Array.from(selectFields, (el) => new SelectField(el))
